import React, { Fragment, useEffect, useState } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import { postMethod } from "../../../../_services/_postMethod";
import Loader from "../../../modules/loader";

const BranchUsers = (props) => {
  const [grid, setGrid] = React.useState([]);
  const [load, setLoad] = React.useState(false);
  const editRecord = (val) => {
    var temp = window.btoa(val);
    console.log(temp);
    props.history.push("/company/Branch-users/add?id=" + temp);
  };

  const [gridParam, setGridParam] = useState({});
  const columns = [
    {
      key: "full_name",
      text: "Full Name",
      align: "left",
      sortable: true,
    },
    {
      key: "mobile",
      text: "Mobile",
      align: "left",
      sortable: true,
    },
    {
      key: "email",
      text: "Email",
      sortable: true,
      align: "left",
    },
    {
      key: "disable",
      text: "Status",
      className: "action",
      width: 100,
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            {record.disable == "0" ? <h6 className="text-success">active</h6> :  <h6 className="text-danger">Deactive</h6> }
          </Fragment>
        );
      },
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 100,
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <button
              className="btn btn-link btn-sm"
              onClick={() => editRecord(record.user_id)}
              style={{ marginRight: "5px" }}
            >
              <i className="fa fa-edit"></i>
            </button>
          </Fragment>
        );
      },
    },
  ];

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50],
  };

  useEffect(() => {
    setLoad(true);
    postMethod("api/masters/user/browse", gridParam).then((data) => {
      setGrid(data);
      setLoad(false);
    });
  }, []);

  return (
    <>
      {load ? <Loader /> : null}
      <div className="card card-custom gutter-b">
        <div className="card-header">
          <div className="card-title">
            <h3 className="card-label">Branch User</h3>
          </div>
          <div className="card-toolbar">
            <a
              href="/company/Branch-users/add"
              className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3"
            >
              <i className="flaticon2-user"></i> Add Branch User
            </a>
          </div>
        </div>
        <div className="card-body">
          <ReactDatatable config={config} records={grid} columns={columns} />
        </div>
      </div>
    </>
  );
};

export default BranchUsers;
